export default async function EditSplitPlanApi(
  id,
  title,
  description,
  target,
  targetDate,
  assignTo,
  attributes,
  scaleId,
  scaleUnitId,
  cascadeFromSplitPlans
) {
  let res = "";
  try {
    const body = {
      id: id,
      title: title,
      description: description || "",
      target: target,
      targetDate: targetDate || "",
      assignTo: assignTo,
      attributes: attributes,
      scaleId: scaleId,
      scaleUnitId: scaleUnitId,
      cascadeFromSplitPlans: cascadeFromSplitPlans,
    };

    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/split-plan`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
        console.log(response);
      })
      .catch((error) => {
        console.error("Error editing top level plan: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
